import { Grid } from '@mui/material';
import { useSnackbar } from "notistack";
import { useEffect, useState } from 'react';
import ModuleService from '../../PermissionManagmentPlugin/services/api/module-service';
import PermissionService from '../../PermissionManagmentPlugin/services/api/permission-service';
import AccessControlService from '../services/api/access-control-service';

import CustomCheckbox from "../../../core/components/common/custom-checkbox.component"
import SavePermission from './save-permission.component';
import CustomCommonBox from '../../../core/components/common/custom-common-box.component';

const PermissionList = ({row}) => {

    const { enqueueSnackbar } = useSnackbar();
    const [module, setModule] = useState([])
    const [permission, setPermission] = useState([])
    const [permissionList, setPermissionList] = useState([])
    const [currentPermission, setCurrentPermission] = useState([])

    const fetchData = () => {
        ModuleService.listModules().then((res) => {
            let apiResponse = res.data;
            console.log("listModules", apiResponse)
            setModule(apiResponse.data)
        }).catch((error) => {
            const errorMessage = error?.response?.data?.error || error.message;
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 2000
            })
        })

        PermissionService.listAllPermissions().then((res) => {
            let apiResponse = res.data;
            console.log("listAllPermissions", apiResponse)
            setPermission(apiResponse.data)

        }).catch((error) => {
            const errorMessage = error?.response?.data?.error || error.message;
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 2000
            })
        })
    };

    const fetchRoleAccessData = () => {
        let parameters = {
            limit: 1000,
            roleId : row.id
        }

        AccessControlService.roleAccess(parameters).then((res) => {
            let apiResponse = res.data;
            console.log("roleAccess", apiResponse)
            // setRoleAccess(apiResponse.data)
            const rolePermission = apiResponse.data.map(perm => ({
                id: perm.permission.id,
                fn: perm.permission.fn
            }));
            
            setPermissionList(rolePermission);
            setCurrentPermission(rolePermission);

            // Log the updated permissionList after the state has been set
            console.log("permissionList", rolePermission);
        }).catch((error) => {
            const errorMessage = error?.response?.data?.error || error.message;
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 2000
            })
        })
    };

    useEffect(() => {
        fetchData();
        fetchRoleAccessData()
    }, []);

    
    // Function to add a permission by id
    const addPermission = (permissionSelected) => {
        if (permissionSelected && !permissionList.some(p => p.id === permissionSelected.id)) {
            setPermissionList(prevList => [...prevList, permissionSelected]);
        }

    };

    // Function to remove a permission by id
    const removePermission = (permissionSelected) => {
        setPermissionList(prevList => prevList.filter(p => p.id !== permissionSelected.id));
    };


    const handleCheckboxChange = (event, id, fn) => {
        const { checked } = event.target;
        console.log("checked", checked)
       
        const permissionSelected = {
            id: id,
            fn: fn
        }

        if(checked) {
            addPermission(permissionSelected)
        }
        else{
            removePermission(permissionSelected)
        }
    }

    const handleCheckedValue = (fnValue) => {
        return permissionList.some(item => item.fn === fnValue);
    };

    return (
        <Grid spacing={2}>
           
            <SavePermission setCurrentPermission={setCurrentPermission}  row={row} permissionList={permissionList} currentPermission={currentPermission}  enqueueSnackbar={enqueueSnackbar}   />

            {module.map((item) => (
                <CustomCommonBox id ={item.id} label= {item.module_name} >
                    <Grid container spacing={2}>
                            {permission
                            .filter(perm => perm.module_id === item.id) 
                            .map((fnItem) => (
                                <Grid item xs={3} key={item.id}>
                                    <CustomCheckbox 
                                        id= {fnItem.id}
                                        label= {fnItem.fn}
                                        handleCheckedValue={()=> handleCheckedValue(fnItem.fn)}
                                        handleCheckboxChange={(event) =>handleCheckboxChange(event, fnItem.id, fnItem.fn)}
                                        />
                                </Grid>
                            ))}
                   </Grid>
                </CustomCommonBox>
            ))}
        </Grid>
    )
}

export default PermissionList